<!--
 * @Descripttion:选择字段弹窗
 * @Author: zenghua.wang
 * @Date: 2021-06-25 15:30:23
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-01-12 18:04:20
-->
<template>
  <el-dialog
    :title="dialog.title"
    :visible.sync="dialog.show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :modal-append-to-body="false"
    append-to-body
    width="50%"
  >
    <el-form
      ref="form"
      size="small"
      :model="form"
      :rules="rules"
      label-width="120px"
      label-suffix=":"
    >
      <el-form-item
        label="选择字段"
        :prop="validate.includes('prop') ? 'prop' : ''"
      >
        <el-select
          style="width:300px"
          v-model="form.prop"
          clearable
          filterable
          allow-create
          default-first-option
          :popper-append-to-body="false"
          placeholder="请选择"
          @change="setFormProp"
        >
          <el-option
            v-for="feild in main.apiFieldList"
            :key="feild.value"
            :label="feild.label"
            :disabled="feild.disabled"
            :value="feild.label"
          ></el-option>
        </el-select>
        <div class="xa-form-tips">备注: 若没有可供选择的字段，可以手动输入！</div>
      </el-form-item>

      <el-form-item
        label="重命名"
        :prop="validate.includes('label') ? 'label' : ''"
        v-if="rename"
      >
        <el-input
          style="width:300px"
          v-model="form.label"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item
        label="展示类型"
        :prop="validate.includes('type') ? 'type' : ''"
        v-if="isShowType"
      >
        <el-radio-group v-model="form.type">
          <el-radio
            v-for="(item, index) in showType"
            :key="index"
            :label="item.value"
          >{{ item.label }}</el-radio>
        </el-radio-group>

        <template v-for="(item, index) in showType">
          <div
            class="xa-form-tips"
            :key="index"
            v-if="item.tips"
          >{{item.tips}}</div>
        </template>
      </el-form-item>

      <el-form-item
        label="最大值"
        v-if="max && form.type==='value'"
      >
        <el-input
          style="width:300px"
          v-model="form.max"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button
        size="small"
        @click="dialog.show = false"
      >取 消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="onSubmit"
      >确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { isEmpty } from '@/dragComponents/utils'
import { echartConfig } from '@/dragComponents/model/default.js'

export default {
  name: 'config-field-dialog',
  inject: ['main'],
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {}
      }
    },
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    column: {
      type: [Object, Array]
    },
    showType: {
      type: Array,
      default: echartConfig.showType
    },
    isShowType: {
      type: Boolean,
      default: true
    },
    rename: {
      type: Boolean,
      default: true
    },
    max: {
      type: Boolean,
      default: false
    },
    validate: {
      type: Array,
      default: () => {
        return ['prop', 'label', 'type']
      }
    }
  },
  data() {
    return {
      form: {},
      rules: {
        prop: [{ required: true, message: '请选择', trigger: 'blur' }],
        label: [{ required: true, message: '请输入', trigger: 'blur' }],
        type: [{ required: true, message: '请选择', trigger: 'blur' }]
      }
    }
  },
  watch: {
    column(val) {
      this.form = val
    },
    form: {
      handler(val) {
        this.$emit('update:column', val)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    setFormProp(e) {
      if (isEmpty(e)) return
      let label = isEmpty(e.label) ? e : e.label
      if (isEmpty(e.label)) {
        this.$nextTick(() => {
          this.form.prop = label
        })
      } else {
        this.form.prop = label
      }
    },
    onSubmit() {
      this.$refs.form.validate((bool) => {
        if (bool) {
          this.$emit('change', this.form)
          this.dialog.show = false
        }
      })
    }
  }
}
</script>
